import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './api-base.token';
import { BusinessAccount, CreateBusinessRequest, UpdateBusinessRequest } from './models';

@Injectable({ providedIn: 'root' })
export class BusinessesApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  list() {
    return this.http.get<BusinessAccount[]>(`${this.apiBaseUrl}/api/businesses`);
  }

  create(payload: CreateBusinessRequest) {
    return this.http.post<BusinessAccount>(`${this.apiBaseUrl}/api/businesses`, payload);
  }

  update(id: string, payload: UpdateBusinessRequest) {
    return this.http.patch<BusinessAccount>(`${this.apiBaseUrl}/api/businesses/${id}`, payload);
  }

  delete(id: string) {
    return this.http.delete<boolean>(`${this.apiBaseUrl}/api/businesses/${id}`);
  }
}
